// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__N-Vnq","loaderOuter":"PageOverlayLoader_loaderOuter__36NYl"};